import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import i18n from './i18n/i18n';

const detectUserLanguage = () => {
  const browserLang = navigator.language.toLowerCase();
  const country = browserLang.split('-')[1]?.toUpperCase();
  
  if (country === 'PL' || browserLang.startsWith('pl')) {
    return 'pl';
  }
  return 'en';
};

i18n.changeLanguage(detectUserLanguage());

const updateMetaTags = (lang: string) => {
  const metaTitle = document.querySelector('meta[name="title"]');
  const metaDescription = document.querySelector('meta[name="description"]');
  const metaKeywords = document.querySelector('meta[name="keywords"]');
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  const twitterDescription = document.querySelector('meta[name="twitter:description"]');
  const title = document.querySelector('title');
  const htmlLang = document.documentElement;
  const ogLocale = document.querySelector('meta[property="og:locale"]');

  if (lang === 'pl') {
    htmlLang.setAttribute('lang', 'pl');
    if (title) title.textContent = 'Market Engine | Sklepy Internetowe B2B i Detaliczne';
    if (metaTitle) metaTitle.setAttribute('content', 'Market Engine | Sklepy Internetowe B2B i Detaliczne');
    if (metaDescription) metaDescription.setAttribute('content', 'Budujemy sklepy B2B dla hurtowni i sklepy detaliczne dla sprzedawców. Sklepy wielojęzyczne, optymalizacja katalogu produktów.');
    if (metaKeywords) metaKeywords.setAttribute('content', 'sklep internetowy, b2b, hurtownia, sklep online, platforma b2b, sklep wielojęzyczny, katalog produktów, sprzedawcy allegro');
    if (ogTitle) ogTitle.setAttribute('content', 'Market Engine | Sklepy Internetowe B2B i Detaliczne');
    if (ogDescription) ogDescription.setAttribute('content', 'Budujemy sklepy B2B dla hurtowni i sklepy detaliczne dla sprzedawców. Sklepy wielojęzyczne i optymalizacja katalogu produktów.');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Market Engine | Sklepy Internetowe B2B i Detaliczne');
    if (twitterDescription) twitterDescription.setAttribute('content', 'Sklepy B2B i detaliczne, wielojęzyczne, z optymalizacją katalogu produktów.');
    if (ogLocale) ogLocale.setAttribute('content', 'pl_PL');
  } else {
    htmlLang.setAttribute('lang', 'en');
    if (title) title.textContent = 'Market Engine | B2B & Retail E-commerce Stores';
    if (metaTitle) metaTitle.setAttribute('content', 'Market Engine | B2B & Retail E-commerce Stores');
    if (metaDescription) metaDescription.setAttribute('content', 'We build B2B e-commerce stores for wholesalers and retail online stores for sellers. Multilingual stores, product catalog optimization.');
    if (metaKeywords) metaKeywords.setAttribute('content', 'e-commerce, b2b store, online store, wholesale platform, multilingual store, product catalog, allegro sellers');
    if (ogTitle) ogTitle.setAttribute('content', 'Market Engine | B2B & Retail E-commerce Stores');
    if (ogDescription) ogDescription.setAttribute('content', 'We build B2B e-commerce stores for wholesalers and retail online stores. Multilingual stores, product catalog optimization.');
    if (twitterTitle) twitterTitle.setAttribute('content', 'Market Engine | B2B & Retail E-commerce Stores');
    if (twitterDescription) twitterDescription.setAttribute('content', 'B2B and retail e-commerce stores. Multilingual, with product catalog optimization.');
    if (ogLocale) ogLocale.setAttribute('content', 'en_US');
  }
};

i18n.on('languageChanged', (lang) => {
  updateMetaTags(lang);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
